/**
 * Created by imranexpt on 06/04/2016.
 */
(function() {
    /** @ngInject */
    function ConnectedRestsCtrl($scope, $state) {
        if(typeof(connected_restaurants) === 'undefined') $state.go('/');
        $scope.connected_restaurants = connected_restaurants;
        $scope.loadWidgetUrl = function(hash){
            window.location = '/reservation/?hash=' + hash;
            return;
        };
    }

    angular.module("Waiteraid").controller("ConnectedRestsCtrl", ConnectedRestsCtrl);
})();
